import { createTransport } from "./transportFactory.js";

const { transport, baseUrl } = createTransport("codebase");

export const codebaseTransport = transport;
export const CODEBASE_BASE_URL = baseUrl;
